type CapitalizeMode = 'word' | 'sentence' | 'title';

export const capitalize = (
    text: string,
    mode: CapitalizeMode = 'word',
    separator: string | RegExp = /\s+/
): string => {
    if (!text) return '';

    const cleanText = text.trim().toLowerCase();

    switch (mode) {
        case 'word':
            return cleanText.charAt(0).toUpperCase() + cleanText.slice(1);

        case 'sentence':
            return cleanText.replace(/^\w/, (match) => match.toUpperCase());

        case 'title':
            return cleanText
                .split(separator)
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');

        default:
            return cleanText;
    }
};

/**
 * Converts a snake_case or camelCase field name to a human-readable label.
 * E.g., "public_title" => "Public title", "protocolVersion" => "Protocol version"
 */
export const humanizeField = (field: string): string => {
    if (!field) return '';

    // Convert camelCase to snake_case first
    const snake = field.replace(/([a-z])([A-Z])/g, '$1_$2');

    // Replace underscores or hyphens with space
    const spaced = snake.replace(/[_-]+/g, ' ');

    // Capitalize like a sentence
    return capitalize(spaced, 'sentence');
};
